<template>
  <div>
    <GroupName  v-model="form.name" :no-save="noSave" :errors-post="errorsPost.name || []"  />
  </div>
</template>

<script>
import GroupName from "../../../question/questions/will/group/GroupName";

export default {
  name: 'GroupWill',
  components: {GroupName},
  mixins: [],
  watch: {
    form: {
      deep: true,
      immediate: false,
      handler(value) {
        // group of people form fields are not saved at field level as they are in json array, so watch
        // form and save whole form to json data
        this.$emit('save', value)
      }
    }
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    noSave: {
      type: Boolean,
      default: true
    },
    errorsPost: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    form: {
      set(value) {
        this.$emit('input', value)
      },
      get() {
        return this.value
      }
    }
  }
}
</script>